import React from 'react';
import PropTypes from 'prop-types';

import connectUI from '../ui/UIConnector';
import suitcss from '../../../helpers/suitcss';

const componentName = 'CreditCardInfo';

function CreditCardInfo({ data, ui }) {
  return (
    <div className={suitcss({ componentName })}>
      <p>
        <span>{ui.guiPaymentCreditCardHolder} </span>
        <span className={suitcss({ componentName, descendantName: 'dataValue' })}>
          { data.holder }
        </span>
      </p>
      <p>
        <span>{ui.guiPaymentCreditCardType} </span>
        <span className={suitcss({ componentName, descendantName: 'dataValue' })}>
          { data.brand }
        </span>
      </p>
      <p>
        <span>{ui.guiPaymentCreditCardNumber} </span>
        <span className={suitcss({ componentName, descendantName: 'dataValue' })}>
          **** **** **** { data.last4Digits }
        </span>
      </p>
      <p>
        <span>{ui.guiPaymentCreditCardExpiryDate} </span>
        <span className={suitcss({ componentName, descendantName: 'dataValue' })}>
          { data.expiryMonth }/{ data.expiryYear }
        </span>
      </p>
    </div>
  );
}

CreditCardInfo.propTypes = {
  data: PropTypes.object.isRequired,
  ui: PropTypes.shape({
    guiPaymentCreditCardNumber: PropTypes.string.isRequired,
    guiPaymentCreditCardExpiryDate: PropTypes.string.isRequired,
    guiPaymentCreditCardType: PropTypes.string.isRequired,
    guiPaymentCreditCardHolder: PropTypes.string.isRequired,
  }).isRequired,
};

export default connectUI()(CreditCardInfo);
